import { QrcodeOutlined, SearchOutlined, MobileOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';

import HeaderLink from 'components/Pages/Admin/CheckinPage/QrCodeScanner/Header/DrawerContent/HeaderLink';
import { StaffUser } from 'components/Pages/Admin/CheckinPage/QrCodeScanner/types';

import styles from './styles.module.css';

type DrawerContentProps = {
  staffUser: StaffUser | null;
  loading: boolean;
  onOpenCheckinHistoryModal: () => void;
  hasCheckinHistory: boolean;
  closeDrawer: () => void;
  openManualCheckin: () => void;
};

const DrawerContent = ({
  staffUser,
  loading,
  onOpenCheckinHistoryModal,
  hasCheckinHistory,
  closeDrawer,
  openManualCheckin
}: DrawerContentProps) => {
  if (loading) {
    return <Skeleton />;
  }

  return (
    <div className={styles.content}>
      <div className={styles.infoContainer}>
        <p className={styles.mainText}>Olá, {staffUser?.name}</p>
        <p className={styles.emailText}>{staffUser?.email}</p>
      </div>
      <div className={styles.divider} />

      <p className={styles.mainText}>Check-ins realizados: {staffUser?.checkins}</p>
      <div className={styles.divider} />

      <HeaderLink
        to='#'
        icon={<QrcodeOutlined />}
        text='Fazer Check-in via QR Code'
        isLink={false}
        onClick={closeDrawer}
      />
      <HeaderLink
        to='#'
        icon={<SearchOutlined />}
        text='Fazer Check-in Manual'
        isLink={false}
        onClick={() => {
          openManualCheckin();
          closeDrawer();
        }}
      />

      <HeaderLink
        to='#'
        icon={<MobileOutlined />}
        text='Check-ins deste credenciador'
        isLink={false}
        disabled={!hasCheckinHistory}
        onClick={onOpenCheckinHistoryModal}
      />

      <HeaderLink
        to='#'
        icon={<QuestionCircleOutlined />}
        text='Como utilizar o Check-in via QR Code?'
        showDivider={false}
      />
    </div>
  );
};

export default DrawerContent;
